import { getApiHost, getHeaders } from './config';

export const fetchSubscriptionComponentData = async (params) => {
  const { env, countryIso, language, firstRow, secondRow } = params;

  const apiUrl = new URL(`${getApiHost(env)}/subscription-component-data/${countryIso}`);
  if (firstRow) apiUrl.searchParams.append('firstRow', firstRow);
  if (secondRow) apiUrl.searchParams.append('secondRow', secondRow);

  const response = await window.fetch(apiUrl.href, {
    credentials: 'include',
    headers: getHeaders(env),
  });

  return response.json().then((data) => ({ ...data, language, countryIso }));
};
